module.exports = __webpack_public_path__ + "img/admin-logo.901bd6e1.png";